module.exports = __webpack_public_path__ + "fonts/opensans-italic.88f5b7ef.woff";